import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { defineComponent, PropType } from 'vue';
import { useAuthStore } from '@/stores/auth';
import { useUserStore } from '@/stores/user';
import User from '../types/User';
import { polarClient } from '@/lib/polar';

interface props {
    user: User;
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'PolarSub' },
  __name: 'PolarSub',
  emits: ["sucribed"],
  setup(__props, { expose: __expose, emit: __emit }) {





const emit = __emit;


const authStore = useAuthStore();
const userStore = useUserStore();
const router = useRouter();

const productId_sub = ref(process.env.VUE_APP_POLAR_PRODUCT_ID_SUB || '');
const productId_once = ref(process.env.VUE_APP_POLAR_PRODUCT_ID_ONCE || '');

const supaUser = ref(authStore.session?.user?.id || null);
const loading = ref(false);
const error = ref<string | null>(null);


const openCheckout = async () => {
    const theme = 'light'
    console.log(productId_once.value)
    console.log(productId_once.value)

    if (!productId_sub.value) {
        console.log('Polar product ID is minssing!')
        error.value = 'Product ID of Subscription config error'

    }

    loading.value=true;
    error.value=null;

    try {
        const checkout = await polarClient.checkouts.create({
            products: [productId_sub.value, productId_once.value],
            successUrl: `${window.location.origin}/success?checkout_id={CHECKOUT_ID}`,
            metadata: {
            user_id: supaUser.value || '',
      },
    });

    window.location.href = checkout.url;


        } catch (err: any) {
            console.error('Failed to create Polar checkout:', err);
            error.value = err.message || 'Failed to start checkout process';
        } finally {
            loading.value = false;
        }
    };

__expose({
  openCheckout,
  loading,
  error
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      class: "subscribe-btn",
      onClick: openCheckout
    }, "Subscribe")
  ]))
}
}

})